<template>
  <div>
    <el-header>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>保函管理</el-breadcrumb-item>
        <!-- <el-breadcrumb-item>投标保函</el-breadcrumb-item> -->
      </el-breadcrumb>
    </el-header>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="全部" name=""></el-tab-pane>
      <el-tab-pane label="投标保函" name="01"></el-tab-pane>
      <el-tab-pane label="履约保函" name="02"></el-tab-pane>
      <el-tab-pane label="预付款保函" name="04"></el-tab-pane>
      <el-tab-pane label="质量保证保函" name="03"></el-tab-pane>
    </el-tabs>
    <el-form :inline="true" class="demo-form-inline">
      <el-form-item label="申请时间">
        <el-date-picker
          size="small"
          v-model="timerArr"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
          @change="timerBtn"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="订单状态">
        <el-select v-model="formModel.status" placeholder="请选择">
          <el-option
            v-for="item in statusList"
            :key="item.code"
            :label="item.description"
            :value="item.code"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="searchBtn"
          >查询</el-button
        >
        <el-button size="small" @click="resetBtn">重置</el-button>
      </el-form-item>
    </el-form>
    <div style="padding: 20px; background: #fff">
      <!-- <el-button
        style="float: right; margin-bottom: 20px"
        size="small"
        type="primary"
        @click="applyFor"
        >申请保函</el-button
      > -->
      <div></div>
      <el-dropdown
        @command="applyFor"
        style="float: right; margin-bottom: 20px"
      >
        <el-button type="primary" size="medium">
          申请保函<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="01">投标保函</el-dropdown-item>
          <el-dropdown-item command="02">履约保函</el-dropdown-item>
          <el-dropdown-item command="04">预付款保函</el-dropdown-item>
          <el-dropdown-item command="03">质量保证保函</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-table :data="tableData" v-loading="dataLoading" border>
        <el-table-column
          label="序号"
          type="index"
          width="50"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="projectName"
          label="项目名称"
          align="left"
          header-align="center"
        ></el-table-column>
        <el-table-column
          prop="guaranteeCategory"
          label="保函分类"
          align="left"
          header-align="center"
        >
          <template slot-scope="scope">
            {{
              scope.row.guaranteeCategory == '01'
                ? '投标保函'
                : scope.row.guaranteeCategory == '02'
                ? '履约保函'
                : scope.row.guaranteeCategory == '03'
                ? '质量保证保函'
                : scope.row.guaranteeCategory == '04'
                ? '预付款保函'
                : ''
            }}
          </template>
        </el-table-column>
        <el-table-column
          prop="guaranteeMoney"
          label="担保金额（元）"
          align="left"
          header-align="center"
        >
          <template slot-scope="scope">{{
            formatCurrency(Number(scope.row.guaranteeMoney))
          }}</template>
        </el-table-column>
        <el-table-column
          prop="guaranteePayMoney"
          label="支付金额（元）"
          align="left"
          header-align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.guaranteePayMoney || '--' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="created"
          label="申请时间"
          align="left"
          header-align="center"
        >
          <template slot-scope="scope">{{
            $parseTime(scope.row.created)
          }}</template>
        </el-table-column>
        <el-table-column
          prop="statusName"
          label="订单状态"
          align="left"
          header-align="center"
        ></el-table-column>
        <el-table-column prop="date7" label="操作" width="200" align="center">
          <template slot-scope="scope">
            <div class="table_btn_box">
              <el-button
                v-if="
                  scope.row.guaranteeCategory === '01' &&
                  scope.row.status === '00'
                "
                type="text"
                size="small"
                @click="payClick(scope.row)"
                >去支付</el-button
              >
              <!-- <el-button type="text" size="small" @click="editClick(scope.row)"
                >去编辑</el-button
              > -->
              <el-button
                class="operatorBtn"
                size="mini"
                v-if="
                  scope.row.guaranteeCategory !== '01' &&
                  scope.row.status === '99'
                "
                type="text"
                @click="editClick(scope.row)"
                >去编辑</el-button
              >
              <el-button
                class="operatorBtn"
                size="mini"
                v-if="
                  scope.row.guaranteeCategory === '01' &&
                  scope.row.status === '00'
                "
                type="text"
                @click="editClick(scope.row)"
                >去编辑</el-button
              >
              <el-button
                type="text"
                size="small"
                @click="detailClick(scope.row)"
                >查看详情</el-button
              >
              <el-button
                v-if="
                  scope.row.status === '01' ||
                  scope.row.status === '04' ||
                  scope.row.status === '05'
                "
                type="text"
                size="small"
                @click="causeClick(scope.row)"
                >查看原因</el-button
              >
              <el-button
                type="text"
                size="small"
                @click="downClick(scope.row)"
                v-if="scope.row.status === '03' || scope.row.status === '06'"
                >下载保函</el-button
              >
              <el-button
                type="text"
                size="small"
                @click="goInvoiceAdmin(scope.row)"
                v-if="scope.row.status === '03'"
                >申请开票</el-button
              >
              <el-button
                v-if="scope.row.status === '04' || scope.row.status === '05'"
                type="text"
                size="small"
                @click="rmbClick(scope.row)"
                >钱款去向</el-button
              >
              <el-button
                v-if="
                  scope.row.guaranteeCategory !== '01' &&
                  (scope.row.status === '00' || scope.row.status === '02')
                "
                type="text"
                size="small"
                @click="signUploadBtn(scope.row)"
              >
                {{
                  scope.row.isFixSignDocs ? '编辑' : '提交'
                }}签约资料</el-button
              >
              <el-button
                v-if="
                  scope.row.guaranteeCategory !== '01' &&
                  scope.row.status === '00'
                "
                type="text"
                size="small"
                @click="etplegaPayClick(scope.row)"
                >{{
                  scope.row.isSubmitPayVoucher ? '修改' : '提交'
                }}付款凭证</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div style="padding-top: 20px">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog title="" center :visible.sync="dialogVisible" width="40%">
      <el-steps direction="vertical" :active="elStepsActive">
        <el-step icon="el-icon-circle-check">
          <template slot="description">
            <div class="steps_box">
              <p>支付完成</p>
              <p>
                {{ runningWater[0] && $parseTime(runningWater[0].created) }}
              </p>
            </div>
          </template>
        </el-step>
        <el-step icon="el-icon-circle-check">
          <template slot="description">
            <div class="steps_box">
              <p>已拒保，运营人员正在进行退款审核</p>
              <p>
                {{ runningWater[1] && $parseTime(runningWater[1].created) }}
              </p>
            </div>
          </template>
        </el-step>
        <el-step icon="el-icon-circle-check">
          <template slot="description">
            <div class="steps_box">
              <p>运营人员审核完毕，请等待银行处理</p>
              <p>
                {{ runningWater[2] && $parseTime(runningWater[2].created) }}
              </p>
            </div>
          </template>
        </el-step>
        <el-step icon="el-icon-circle-check">
          <template slot="description">
            <div class="steps_box">
              <p>银行处理完毕，钱款已经原路返回，请及时查收</p>
              <p>
                {{ runningWater[3] && $parseTime(runningWater[3].created) }}
              </p>
            </div>
          </template>
        </el-step>
      </el-steps>
    </el-dialog>
    <el-dialog
      v-if="dialogVisibleEtplega"
      title=""
      :visible.sync="dialogVisibleEtplega"
      width="750px"
      :close-on-click-modal="false"
    >
      <payMsg
        @childEditBtn="childEditBtn"
        :guaranteeId="guaranteeId"
        :guaranteePayMoney="guaranteePayMoney"
      ></payMsg>
    </el-dialog>
  </div>
</template>

<script>
import {
  getListZtb,
  getListGuaranteeStatus,
  getListRefundMoneyHis
} from '@/api/adminData/index.js'
import {
  detailUpload,
  downloadFile,
  downloadGuaranteeFile
} from '@/api/user/file'
import payMsg from '@/components/payMsg.vue'
export default {
  components: {
    payMsg
  },
  data() {
    return {
      guaranteeId: '',
      guaranteePayMoney: '', // 支付金额
      dialogVisibleEtplega: false,
      activeName: '0',
      dataLoading: false,
      runningWater: [], // 钱款去向
      total: 0,
      statusList: [],
      dialogVisible: false,
      elStepsActive: 1,
      heightN: window.innerHeight - 100 + 'px',
      region: '',
      tableData: [],
      timerArr: '',
      formModel: {
        guaranteeCategory: '', // 01：投标保函；02:履约保函;03:质量保函;04:预付款保
        beginCreated: '', // 申请开始时间
        endCreated: '', // 申请结束时间
        pageSize: 10, // 每页条数
        currentPage: 1, // 当前页
        status: '' // 保函状态 00：未处理;01:已拒保；03：已付款；04:已开函 05：已拒保（未退款）;06：已拒保（已退款）
      },
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      }
    }
  },
  mounted() {
    this.heightN = window.innerHeight - 100 + 'px'
    this.getListData()
    this.getListStatus()
  },
  methods: {
    etplegaPayClick(row) {
      // 提交付款凭证
      this.dialogVisibleEtplega = true
      this.guaranteeId = row.guid
      this.guaranteePayMoney = row.guaranteePayMoney
    },
    childEditBtn() {
      this.dialogVisibleEtplega = false
      this.formModel.currentPage = 1
      this.getListData()
    },
    handleClick(tab, event) {
      // tab切换
      this.formModel.guaranteeCategory = tab.name
      this.formModel.currentPage = 1
      this.getListData()
    },
    handleCurrentChange(v) {
      // 分页
      this.formModel.currentPage = v
      this.getListData()
    },
    getListStatus() {
      getListGuaranteeStatus().then((res) => {
        if (res.success) {
          this.statusList = res.result
        } else {
          this.$message.error(res.message)
        }
      })
    },
    timerBtn() {
      // 选择保函有效期
      this.formModel.beginCreated = Date.parse(this.timerArr[0])
      this.formModel.endCreated =
        Date.parse(this.timerArr[1]) + 3600 * 1000 * 24
    },

    getListData() {
      // 数据列表
      this.dataLoading = true
      getListZtb(this.formModel).then((res) => {
        this.dataLoading = false
        if (res.success) {
          this.tableData = res.result.records
          this.total = res.result.total
        } else {
          this.$message.error(res.message)
        }
        this.contentLoading = false
      })
    },
    searchBtn() {
      // 查询
      this.formModel.currentPage = 1
      this.getListData()
    },
    resetBtn() {
      // 重置
      this.timerArr = ''
      this.formModel = {
        beginCreated: '', // 申请开始时间
        endCreated: '', // 申请结束时间
        pageSize: 10, // 每页条数
        currentPage: 1, // 当前页
        status: '' // 保函状态 00：未处理;01:已拒保；03：已付款；04:已开函 05：已拒保（未退款）;06：已拒保（已退款）
      }
      this.getListData()
    },
    applyFor(command) {
      if (command == '01') {
        this.$router.push({ path: '/applyFor' })
      } else {
        this.$router.push({
          path: '/applyForMore',
          query: { guaranteeCategory: command }
        })
      }
    },
    payClick(row) {
      this.$router.push({
        path: '/applyForPay',
        query: {
          type: 1,
          guaranteeId: row.guid
        }
      })
    },
    editClick(row) {
      // 编辑
      if (row.guaranteeCategory == '01') {
        this.$router.push({
          path: '/applyFor',
          query: {
            guaranteeId: row.guid
          }
        })
      } else {
        this.$router.push({
          path: '/applyForMore',
          query: {
            guaranteeId: row.guid
          }
        })
      }
    },
    signUploadBtn(row) {
      this.$router.push({
        path: '/signUpload',
        query: {
          guaranteeId: row.guid
        }
      })
    },
    detailClick(row) {
      // 查看详情
      if (row.guaranteeCategory == '01') {
        if (row.status == '00') {
          // 未支付
          this.$router.push({
            path: '/applyForPay',
            query: {
              guaranteeId: row.guid,
              type: 1
            }
          })
        } else if (
          row.status == '03' ||
          row.status == '06' ||
          row.status == '02'
        ) {
          // 已支付
          this.$router.push({
            path: '/applyForPay',
            query: {
              guaranteeId: row.guid,
              type: 2
            }
          })
        } else if (row.status == '04' || row.status == '05') {
          // 已拒绝
          this.$router.push({
            path: '/applyForPay',
            query: {
              guaranteeId: row.guid,
              type: 1,
              isPaybtn: 2
            }
          })
        }
      } else {
        if (row.status == '99') {
          // 待审核
          this.$router.push({
            path: '/applyDetail',
            query: {
              guaranteeId: row.guid
            }
          })
        } else if (row.status == '00') {
          // 未支付
          this.$router.push({
            path: '/applyDetail',
            query: {
              guaranteeId: row.guid,
              isFixSignDocs: row.isFixSignDocs,
              isPage: 2
            }
          })
        } else if (row.status == '01') {
          // 已拒绝
          this.$router.push({
            path: '/applyDetail',
            query: {
              guaranteeId: row.guid,
              isFixSignDocs: row.isFixSignDocs,
              isPage: 1
            }
          })
        } else if (row.status == '02') {
          // 已支付
          this.$router.push({
            path: '/applyDetail',
            query: {
              guaranteeId: row.guid,
              isFixSignDocs: row.isFixSignDocs,
              isPage: 3
            }
          })
        } else if (row.status == '03') {
          // 已开函未开票
          this.$router.push({
            path: '/applyDetail',
            query: {
              guaranteeId: row.guid,
              isPage: 4
            }
          })
        } else if (row.status == '04') {
          // 已拒保未退款
          this.$router.push({
            path: '/applyDetail',
            query: {
              guaranteeId: row.guid,
              isFixSignDocs: row.isFixSignDocs,
              isPage: 1
            }
          })
        } else if (row.status == '05') {
          // 已拒保已退款
          this.$router.push({
            path: '/applyDetail',
            query: {
              guaranteeId: row.guid,
              isFixSignDocs: row.isFixSignDocs,
              isPage: 1
            }
          })
        } else if (row.status == '06') {
          // 已开函已开票
          this.$router.push({
            path: '/applyDetail',
            query: {
              guaranteeId: row.guid,
              isPage: 4
            }
          })
        }
      }
    },
    causeClick(row) {
      this.$alert(row.rejectReason, '拒保原因', {
        confirmButtonText: '知道了'
      })
    },
    goInvoiceAdmin() {
      this.$router.push({
        path: '/invoiceAdmin'
      })
    },
    downClick(row) {
      const data = {
        guid: row.returnGuarantee
      }
      this.dataLoading = true
      detailUpload(data).then((ress) => {
        this.dataLoading = false
        if (ress.success && ress.result) {
          console.log(ress.result)
          this.dataLoading = true
          downloadFile(data).then((res) => {
            this.dataLoading = false
            const content = res.data
            const blob = new Blob([content], { type: 'application/pdf' })
            const fileName = ress.result.fileName
            const elink = document.createElement('a')
            elink.download = fileName
            elink.style.display = 'none'
            elink.href = URL.createObjectURL(blob)
            document.body.appendChild(elink)
            elink.click()
            URL.revokeObjectURL(elink.href) // 释放URL 对象
            document.body.removeChild(elink)
          })
        } else {
          this.$msgError('文件无效')
        }
      })
    },
    rmbClick(row) {
      getListRefundMoneyHis({ guid: row.guid }).then((res) => {
        if (res.success) {
          if (res.result.length == 4) {
            this.elStepsActive = res.result.length
          } else {
            this.elStepsActive = res.result.length - 1
          }

          this.runningWater = res.result
        } else {
          this.$message.error(res.message)
        }
      })
      this.dialogVisible = true
    },
    formatCurrency(number) {
      // 将数字转换为字符串并去除小数点前两位之前的0
      const numberStr = number.toFixed(2).replace(/^0+/, '')
      // 使用正则表达式将每三个数字分隔
      const formatted = numberStr.replace(
        /\d{1,3}(?=(\d{3})+(\.\d*)?$)/g,
        '$&,'
      )
      // 如果小数部分为00，则去除小数点和零
      return formatted.replace(/,\d{2}$/, '')
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-dialog__header {
  padding: 0;
}
.demo-form-inline {
  background: #fff;
  padding: 20px 20px 0 20px;
  margin-bottom: 20px;
}

.steps_box {
  font-size: 14px;

  p {
    padding-bottom: 10px;

    &:last-child {
      padding-bottom: 20px;
    }
  }
}

.table_btn_box {
  text-align: left;
}
</style>
